import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { variant } from 'styled-system';

import { DividerContainerProps } from './types';

const propsNotToForward = ['type', 'size'];

const DividerContainer = styled('div', {
  shouldForwardProp: (prop) =>
    isPropValid(prop) && !propsNotToForward.includes(prop),
})<DividerContainerProps>(
  variant({
    prop: 'orientation',
    variants: {
      vertical: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
      },
    },
  })
);

export default DividerContainer;
